<template>
   <div class="container">
      <div class="row justify-content-center">
         <div class="col-md-5 col-lg-4 my-5">
            <div class="card bg-light bg-gradient shadow-lg rounded-4 animate__animated animate__fadeInDown">
               <div class="card-body bg-sa-card-body p-2">

                  <div v-if="showAlert" :class="['alert', `alert-${alertType}`]" role="alert">
                     <i class="fa-fw fa me-2"
                        :class="alertType === 'success' ? 'fa-check' : 'fa-times'">
                     </i>
                     {{ alertMessage }}
                  </div>

                  <h3 class="card-title text-center mb-2">Reset Password</h3>

                  <form id="resetPasswordForm" autocomplete="off" novalidate @submit.prevent="resetPasswordSubmit">

                     <div class="mb-2">
                        <label for="password" class="form-label">New Password</label>
                        <div class="input-group">
                           <span class="input-group-text">
                              <i class="fa fa-lock"></i>
                           </span>
                           <input
                              v-model="password"
                              @input="handleInputChange"
                              @change="handleInputChange"
                              type="password"
                              class="form-control custom-tooltip-input"
                              id="password"
                              placeholder="Enter new password"
                              required
                              autocomplete="new-password"
                           >
                           <div class="custom-tooltip">
                              Please enter your new password
                              <span class="tooltip-arrow"></span>
                           </div>
                        </div>
                     </div>

                     <div class="mb-3">
                        <label for="confirmPassword" class="form-label">Confirm Password</label>
                        <div class="input-group">
                           <span class="input-group-text">
                              <i class="fa fa-lock"></i>
                           </span>
                           <input
                              v-model="confirmPassword"
                              @input="handleInputChange"
                              @change="handleInputChange"
                              type="password"
                              class="form-control custom-tooltip-input"
                              id="confirmPassword"
                              placeholder="Confirm new password"
                              required
                              autocomplete="new-password"
                           >
                           <div class="custom-tooltip">
                              Please confirm your new password
                              <span class="tooltip-arrow"></span>
                           </div>
                        </div>
                     </div>

                     <div class="d-grid mb-2">
                        <button
                           type="submit"
                           class="btn btn-primary"
                           :disabled="sendingCode || !token"
                        >
                           {{ button_text }}
                        </button>
                     </div>

                  </form>

                  <p class="text-center text-muted mt-3 small bg-sa-login-reg-text">
                     <router-link to="/login/" class="text-decoration-none btn btn-primary d-grid mb-0">
                        Login
                     </router-link>
                  </p>

               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';

export default {
   data() {
      return {
         token: '',
         password: '',
         confirmPassword: '',
         showAlert: false,
         alertType: '',
         alertMessage: '',
         button_text: 'Reset Password',
         sendingCode: false
      };
   },

   created() {
      this.token = this.$route.query.token || '';

      if (!this.token) {
         this.alertType = 'danger';
         this.alertMessage = 'The password reset link is invalid or missing its token.';
         this.showAlert = true;
      }
   },

   methods: {
      handleInputChange(event) {
         this.$validateField(event.target);
      },

      async resetPasswordSubmit() {
         if (this.sendingCode) return; // already sending (e.g. Enter pressed twice)

         const formIsValid = this.$validateForm('#resetPasswordForm');

         if (!formIsValid) {
            return;
         }

         if (!this.token) {
            this.alertType = 'danger';
            this.alertMessage = 'The password reset link is invalid or missing its token.';
            this.showAlert = true;
            return;
         }

         if (this.password !== this.confirmPassword) {
            this.alertType = 'danger';
            this.alertMessage = 'The passwords do not match.';
            this.showAlert = true;
            return;
         }

         this.sendingCode = true;
         this.button_text = 'Resetting...';
         this.showAlert = false;

         const formData = new FormData();
         formData.append('action', 'reset_password');
         formData.append('token', this.token);
         formData.append('password', this.password);
         formData.append('confirm_password', this.confirmPassword);

         try {
            const response = await axios.post('/auth/reset_password.php', formData,{withCredentials: true});

            if (response.data.status === 'success') {
               this.alertType = 'success';
               this.alertMessage = response.data.message || 'Your password has been reset successfully.';
               this.showAlert = true;

               this.password = '';
               this.confirmPassword = '';
            } else {
               this.alertType = 'danger';
               this.alertMessage = response.data.message || 'Unable to reset your password.';
               this.showAlert = true;
            }
         } catch (error) {
            this.alertType = 'danger';
            this.alertMessage = 'Something went wrong! Please try again.';
            this.showAlert = true;
         } finally {
            this.sendingCode = false;
            this.button_text = 'Reset Password';
         }
      }
   }
};
</script>